import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconNode", "text", "_bodyElement", "hideTooltip", "maxTooltipWidth", "useOnDark", "maxChars"];
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { MoveableObject } from 'foundations-components/transitional/components/MoveableObject';
import { TruncateMultiline } from 'foundations-components/transitional/components/TruncateMultiline';
import { CustomModulesIcon } from 'foundations-assets/icons/components/CustomModulesIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_MAX_CHARS = 38;
const DetailText = ({
  children
}) => /*#__PURE__*/_jsx(Text, {
  as: "div",
  typography: "detail-100",
  children: children
});
const EPAddableObject = _ref => {
  let {
      iconNode,
      text,
      _bodyElement,
      hideTooltip = false,
      maxTooltipWidth = '200px',
      useOnDark = false,
      maxChars = DEFAULT_MAX_CHARS
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const disableTooltip = hideTooltip || Boolean(text && text.length <= maxChars);
  return /*#__PURE__*/_jsx(MoveableObject, Object.assign({
    closeable: false,
    truncate: false,
    use: useOnDark ? 'on-dark' : 'default'
  }, rest, {
    children: /*#__PURE__*/_jsx(MediaObject, {
      align: "center",
      itemLeft: iconNode || /*#__PURE__*/_jsx(CustomModulesIcon, {}),
      MediaLeft: Box,
      children: /*#__PURE__*/_jsx(Tooltip, {
        title: text,
        autoPlacement: false,
        placement: 'bottom',
        maxInlineSize: maxTooltipWidth,
        _bodyElement: _bodyElement,
        delay: 0,
        disabled: disableTooltip,
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(TruncateMultiline, {
            maxChars: maxChars,
            Paragraph: DetailText,
            text: text || ''
          })
        })
      })
    })
  }));
};
export default EPAddableObject;